import(/* webpackMode: "eager", webpackExports: ["CrashGate"] */ "/app/src/_components/crash-gate/index.tsx");
